// project imports
import NavGroup from './NavGroup.jsx';

// ==============================|| SIDEBAR MENU LIST ||============================== //

function MenuList({ routes }) {
    const navItems = routes.map(item => {
        if (item.handle?.type) {
            if (item.handle.type !== 'group')
                console.error('Type of route-item has to be "group" or unset. Route:', item);
            else return <NavGroup item={item} key={item.path} />;
        }
    });

    return <>{navItems}</>;
}

export default MenuList;
